import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { OAuthStorage } from 'angular-oauth2-oidc';

@Injectable()
export class IdabusInterceptor implements HttpInterceptor {
    private checkUrl(url: string): boolean {
        if (!url) {
            return false;
        }

        const apiUrl = this.config.getConfig('nextGenServiceUrl', '');
        if (!apiUrl) {
            return false;
        }

        return url.toLowerCase().startsWith(apiUrl.toLowerCase());
    }

    constructor(private config: ConfigService, private authStorage: OAuthStorage) {
    }

    public intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (req.url === 'uploadSaveUrl') {
            return of(new HttpResponse({ status: 200 }));
        }

        if (this.checkUrl(req.url)) {
            const token = this.authStorage.getItem('access_token');
            if (token) {
                const headers = req.headers.set('Authorization', `Bearer ${token}`);
                return next.handle(req.clone({ headers }));
            }
        }

        return next.handle(req);
    }
}